import { render, staticRenderFns } from "./RowBlockPurchaseInsuranceThroughPaymentSystem.vue?vue&type=template&id=3446836e&"
import script from "./RowBlockPurchaseInsuranceThroughPaymentSystem.vue?vue&type=script&lang=js&"
export * from "./RowBlockPurchaseInsuranceThroughPaymentSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports